import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "content has-text-primary" }
const _hoisted_4 = {
  key: 1,
  class: "progress is-primary",
  max: "100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CountDown = _resolveComponent("CountDown")!

  return (_ctx.store.is_initialized === true)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_Calendar, {
          doors: _ctx.store.user_doors
        }, null, 8, ["doors"]),
        _hoisted_1,
        _createElementVNode("div", {
          class: "content",
          innerHTML: _ctx.store.site_config.content
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.store.next_door_target === null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Alle " + _toDisplayString(_ctx.store.user_doors.length) + " Türchen offen! ", 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.store.user_doors.length === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Zeit bis zum ersten Türchen: ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.store.user_doors.length) + " Türchen offen. Zeit bis zum nächsten Türchen: ", 1)
                    ], 64)),
                _createVNode(_component_CountDown, {
                  until: _ctx.store.next_door_target
                }, null, 8, ["until"])
              ], 64))
        ])
      ], 64))
    : (_openBlock(), _createElementBlock("progress", _hoisted_4))
}